// Angular modules
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// External modules
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

// Components
import { ToastComponent } from './components/blocks/toast/toast.component';
import { ProgressBarComponent } from './components/blocks/progress-bar/progress-bar.component';

// Forms
import { FormConfirmComponent } from './components/forms/form-confirm/form-confirm.component';

// Modals
import { ModalWrapperComponent } from './components/modals/modal-wrapper/modal-wrapper.component';
import { PmsAuthModalComponent } from './components/modals/pms-auth-modal/pms-auth-modal.component';

// Layouts
import { LayoutHeaderComponent } from './components/layouts/layout-header/layout-header.component';
import { PageLayoutComponent } from './components/layouts/page-layout/page-layout.component';

// Pipes

// Directives
import { ModalWrapperDirective } from './directives/modal-wrapper.directive';
import { BusyButtonDirective } from './directives/busy-button.directive';
import { LayoutFooterComponent } from './components/layouts/layout-footer/layout-footer.component';
import { NotificationService } from '@services/notification.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormErrorComponent } from '@forms/form-error/form-error.component';
import { IsFormGroupComponent } from '@forms/is-form-group/is-form-group.component';


@NgModule({
  imports:
    [
      // Angular modules
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,

      // External modules
      TranslateModule,
      AngularSvgIconModule,
      NgbModule,
      ModalModule.forRoot(),
    ],
  declarations:
    [
      // Components
      ToastComponent,
      ProgressBarComponent,
      FormErrorComponent,
      IsFormGroupComponent,

      // Forms
      FormConfirmComponent,

      // Modals
      ModalWrapperComponent,
      PmsAuthModalComponent,

      // Layouts
      LayoutHeaderComponent,
      PageLayoutComponent,

      // Pipes

      // Directives
      ModalWrapperDirective,
      BusyButtonDirective,
      LayoutFooterComponent
    ],
  exports:
    [
      // Angular modules
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,

      // External modules
      TranslateModule,
      AngularSvgIconModule,
      NgbModule,

      // Components
      ToastComponent,
      ProgressBarComponent,
      FormErrorComponent,
      IsFormGroupComponent,

      // Forms
      FormConfirmComponent,

      // Modals
      ModalWrapperComponent,
      PmsAuthModalComponent,
      ModalModule,

      // Layouts
      LayoutHeaderComponent,
      PageLayoutComponent,

      // Pipes

      // Directives
      ModalWrapperDirective,
      BusyButtonDirective,
      NgMultiSelectDropDownModule
    ],
  providers:
    [
    ]
})
export class SharedModule { }
